import { useState } from 'react';

import { Box, TextField } from '@mui/material';
import DOMPurify from 'dompurify';

import Typography from '@/components/Typography';
import StepButtons from '@/pages/Onboarding/OnboardingForm/Steps/StepButtons';
import { DomainConfig } from '@/pages/Onboarding/types/recipient.types';

const AboutUser = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  companyName,
  setCompanyName,
  activeStep,
  setActiveStep,
  domainConfig
}: {
  firstName: string;
  setFirstName: (v: string) => void;
  lastName: string;
  setLastName: (v: string) => void;
  companyName: string;
  setCompanyName: (v: string) => void;
  activeStep: number;
  setActiveStep: (v: number) => void;
  domainConfig: DomainConfig | undefined | null;
}) => {
  const [firstNameError, setFirstNameError] = useState<string>('');
  const [lastNameError, setLastNameError] = useState<string>('');
  const [companyNameError, setCompanyNameError] = useState<string>('');
  const validateForm = () => {
    let isValid = true;
    if (firstName.length < 1) {
      setFirstNameError('Please provide first name');
      isValid = false;
    }
    if (lastName.length < 1) {
      setLastNameError('Please provide last name');
      isValid = false;
    }
    if (companyName.length < 1) {
      setCompanyNameError('Please provide company name');
      isValid = false;
    }
    return isValid;
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {!domainConfig?.welcomeMessage && (
        <Typography
          size={24}
          sx={{ fontWeight: 'bold', mb: 1.5 }}
        >
          Great! Please tell us about yourself...
        </Typography>
      )}
      {domainConfig?.welcomeMessage && (
        <Box
          sx={{
            backgroundColor: '#132627',
            borderLeft: 5,
            borderLeftColor: 'success.main',
            pl: 3,
            pr: 4,
            fontSize: 16,
            mb: 3,
            py: 2
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(domainConfig.welcomeMessage)
            }}
          />
        </Box>
      )}
      <TextField
        required
        autoComplete='text'
        error={!!firstNameError}
        helperText={firstNameError}
        id='firstName'
        label='First Name'
        name='firstName'
        sx={{ minWidth: 220, mb: 2 }}
        value={firstName}
        variant='filled'
        onChange={e => {
          if (firstNameError) setFirstNameError('');
          setFirstName(e.target.value);
        }}
      />
      <TextField
        required
        autoComplete='text'
        error={!!lastNameError}
        helperText={lastNameError}
        id='lastName'
        label='Last Name'
        name='lastName'
        sx={{ minWidth: 220, mb: 2 }}
        value={lastName}
        variant='filled'
        onChange={e => {
          if (lastNameError) setLastNameError('');
          setLastName(e.target.value);
        }}
      />

      <TextField
        required
        autoComplete='companyName'
        disabled={!!domainConfig?.company}
        error={!!companyNameError}
        helperText={companyNameError}
        id='companyName'
        label='Company Name'
        name='companyName'
        sx={{
          minWidth: 220,
          mb: 4,
          '& .MuiInputBase-root.Mui-disabled:before': {
            borderBottom: 'none'
          },
          '& .MuiInputBase-root.Mui-disabled:after': {
            borderBottom: 'none'
          }
        }}
        value={companyName}
        variant='filled'
        onChange={e => {
          if (companyNameError) setCompanyNameError('');
          setCompanyName(e.target.value);
        }}
      />
      <StepButtons
        activeStep={activeStep}
        onBackClick={() => {
          setActiveStep(activeStep - 1);
        }}
        onNextClick={() => {
          if (validateForm()) {
            setActiveStep(activeStep + 1);
          }
        }}
      />
    </Box>
  );
};
export default AboutUser;
